import Vue from 'vue'
import VueRouter from 'vue-router'
// import permissionConstant from '@/constants/permissions.js'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Login',
        component: () => import('@/views/Login.vue'),
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/payment-list',
        name: 'PaymentList',
        component: () => import('@/views/paymentList.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/payment-gate/:invoiceNo',
        name: 'PaymentGate',
        component: () => import('@/views/paymentGate.vue')
    },
    {
        path: '/payment-result',
        name: 'PaymentResult',
        component: () => import('@/views/paymentResult.vue')
    },
    // {
    //     path: '/report',
    //     name: 'Report',
    //     component: () => import('@/views/Report.vue'),
    //     meta: {
    //         requiresAuth: false
    //     }
    // },
    {
        path: '/manage',
        name: 'Manage',
        component: () => import('@/views/admin/Login.vue')
    },
    {
        path: '/manage/report',
        name: 'ManageReport',
        component: () => import('@/views/Report.vue')
    },
    {
        path: '/manage/list',
        name: 'ManageList',
        component: () => import('@/views/admin/dashboard.vue')
    },
    {
        path: '/errors',
        name: 'ErrorPage',
        component: () => import('@/views/Errors.vue')
        // meta: {
        //     requiresAuth: false
        // }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(async (_to, _from, next) => {
    if (_to.name !== _from.name) {
        const isLogin = Boolean(sessionStorage.getItem('student'))
        // allow to access error page
        if (_to.name === 'ErrorPage') {
            next()
            return
        }

        if (!_to.name.includes('Manage')) {
            if (_to.name === 'Login' && sessionStorage.getItem('student')) {
                next({ path: '/payment-list' })
            } else {
                if (_to.name !== 'Login' && !isLogin) {
                    next({ path: '/' })
                } else {
                    next()
                }
            }
        } else {
            next()
        }
        // const { permissions } = _to.meta
        // const currentRole = localStorage.getItem('currentRole')
        // // validate permissions
        // if (permissions && permissions.length > 0 && !permissions.includes(currentRole)) {
        //     console.log('no permission')
        //     next({ path: '/errors' })
        // } else {
        //     next()
        // }
    } else {
        next()
    }
})

export default router
